import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { isItemHeldByItemReadingPane } from './helpers/tryRemoveItemFromMailStore';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('tryRemoveItemNormalizedBody', itemId => {
    const mailStore = getMailStore();
    const item = mailStore.items.get(itemId);

    if (isItemHeldByItemReadingPane(itemId)) {
        // The item reference is currently held, we cannot remove normalized body at this time
        // We don’t need to check listview reference because this is only a listview scenario, i.e reload
        // where we need to remove the NormalizedBody from item
        return;
    }

    // Delete the normalizedBody of the item
    if (item) {
        item.NormalizedBody = undefined;
    }
});
